export function processTime(time: string | undefined): string | undefined {
  //SDA time in format of 11:00AM. Need to inject an additional space between 11:00 and AM to make it valid for formatting
  if (time && time.length >= 6) {
    const trimmed = time.trim();
    const suffix = trimmed.substr(trimmed.length - 2, 2);
    if (suffix == "AM" || suffix == "PM") {
      return trimmed.substr(0, trimmed.length - 2) + " " + suffix;
    }
  }
  return time;
}

export function formatedStartTime(time: string) {
  const splittedString = time?.split(":");
  return (
    splittedString.slice(0, 2).join(":") +
    " " +
    splittedString[splittedString.length - 1].split(/\s/).slice(1, 2)
  );
}
